import React, { useState } from "react";
import { BRAND_ICON } from "@/lib/BrandAssets";
import "./Support.css";

const EMAIL = "support@mycruisecommand.com";

export default function Support() {
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  async function submit(event) {
    event.preventDefault();
    setState("sending");
    setError("");
    const data = new FormData(event.currentTarget);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/public/support`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.fromEntries(data.entries())),
      });
      if (!response.ok) throw new Error("delivery failed");
      setState("sent");
    } catch (_error) {
      setError("Your message could not be sent. Please email us directly using the address below.");
      setState("idle");
    }
  }
  return (
    <main className="cc-support" data-testid="cc-public-support">
      <div className="cc-support__sheet">
        <a className="cc-support__brand" href="/" aria-label="Cruise Command home">
          <img src={BRAND_ICON.primary} alt="" width="56" height="56" />
          <span>Cruise Command</span>
        </a>
        <p className="cc-support__eyebrow">Help &amp; support</p>
        <h1>How can we help?</h1>
        <p className="cc-support__intro">
          Questions about Cruise Command? Email our support team at{" "}
          <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. Include a brief description of the issue and the email address on your account. Please do not email passwords, payment card numbers, or passport details.
        </p>
        {state === "sent" ? <p className="cc-support__success" role="status">Thank you. Your message was sent to our support team.</p> : (
          <form className="cc-support__form" onSubmit={submit}>
            <h2>Send us a message</h2>
            <label>Your name<input name="name" required maxLength="100" autoComplete="name" /></label>
            <label>Email address<input name="email" type="email" required maxLength="254" autoComplete="email" /></label>
            <label>What do you need help with?
              <select name="topic" required defaultValue="">
                <option value="" disabled>Select a topic</option>
                <option>Signing in</option><option>Voyage information</option><option>Documents</option><option>Billing</option><option>Account deletion</option><option>Other</option>
              </select>
            </label>
            <label>Message<textarea name="message" required minLength="10" maxLength="3000" rows="6" /></label>
            <div className="cc-support__trap" aria-hidden="true"><label>Website<input name="website" tabIndex="-1" autoComplete="off" /></label></div>
            {error && <p role="alert">{error}</p>}
            <button type="submit" disabled={state === "sending"}>{state === "sending" ? "Sending…" : "Send message"}</button>
          </form>
        )}
        <div className="cc-support__topics">
          <section>
            <h2>Signing in</h2>
            <p>Use the sign-in method linked to your account. If you cannot access your account, tell us which sign-in method you used.</p>
          </section>
          <section>
            <h2>Voyage information</h2>
            <p>For missing or incorrect voyage details, include the voyage name and what needs correcting. Avoid sending sensitive travel documents by email.</p>
          </section>
          <section>
            <h2>Documents</h2>
            <p>If a document will not upload or open, tell us the document type and what happened. Please do not attach sensitive documents to your first email.</p>
          </section>
          <section>
            <h2>Billing</h2>
            <p>For a subscription or payment question, include your account email and a description of the charge. Never send your full card number.</p>
          </section>
          <section>
            <h2>Account deletion</h2>
            <p>See our <a href="/account-deletion">account and data deletion instructions</a>. If you cannot sign in, email us from your registered address and ask for help.</p>
          </section>
        </div>
        <footer className="cc-support__footer">
          <a href="/">Cruise Command</a>
          <a href="/legal/privacy.html">Privacy policy</a>
          <a href="/account-deletion">Account deletion</a>
        </footer>
      </div>
    </main>
  );
}
